export const BASE_URL = 'https://project-labeddit.onrender.com'